// src/components/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ehAdmin } from '../utils/permissoes';

/**
 * Rota restrita a administradores. Usa-se por dentro do ProtectedRoute, que já
 * garante que há sessão.
 *
 * Encaminha em vez de mostrar um erro: quem não é administrador não tem nada a
 * fazer nestes ecrãs, e um 403 vindo da API depois da página montar era pior
 * experiência do que nunca lá chegar.
 */
const AdminRoute = ({ children, para = '/dashboard' }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  return ehAdmin(user) ? children : <Navigate to={para} replace />;
};

export default AdminRoute;
